import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faShoppingCart,
  faTrashAlt,
  faUserCircle,
  faSearch,
  faEnvelope,
  faInbox,
  faArrowCircleUp
  
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faPlus,
  faShoppingCart,
  faTrashAlt,
  faUserCircle,
  faSearch,
  faEnvelope,
  faInbox,
  faArrowCircleUp,
);
